import React from "react";
import { useNavigate } from "react-router-dom";

import imageOne from "../../resource/meditate/internalRetreats/1.png";
import imageFour from "../../resource/meditate/internalRetreats/7.png";
import imageSix from "../../resource/meditate/internalRetreats/3.png";
import imageSeven from "../../resource/meditate/internalRetreats/4.png";
import imageEight from "../../resource/meditate/internalRetreats/8.png";

import imageThree from "../../resource/meditate/internalRetreats/2.png";

import imageFive from "../../resource/meditate/external-retreat/5.png";
import Calendar from '../Calendar/Calendar'
import KutiesLayout from "./KutiesLayout";
const SoloRetreat = () => {
  const navigate = useNavigate();
  const handleClick = (event) => {
    const pathMap = {
      itemBring: "/itemBring",
      timeTabel: "/timeTabel",
      internalRules: "/internalRules",
      soloRetreatRegistration:"/soloRetreatRegistration",
      soloRequest:"/soloRequest"
    };

    const path = event.currentTarget.id;
    const targetPath = pathMap[path];

    if (targetPath) {
      navigate(targetPath);
    }
  };

  return (
    <div className="internalRetreat-page inside-pages">
      <div className="right-box">
        <img
          src={imageOne}
          alt="Right Top Image"
          className="right-image"
          width={300}
        />
      </div>

      <h1 className="font-main dark-gold p-4 mt-4">Silent Solo Retreats</h1>

      <p className="mt-6 h4 p-4">
      Bhaddeka Vihari Monastery and Meditation Centre warmly invite individuals to undertake personal retreats during times when no scheduled retreats are taking place. Guests are welcome to make use of the Dhamma Hall and the peaceful surroundings to strengthen their minds and deepen their mindfulness practice.
      </p>
      <p className="mt-5 h4 p-4">
      Please note that there are no formal meditation teachings provided during these retreats. Participants are expected to meditate independently while following Buddhist principles. If desired, a one-on-one discussion session with a Sangha member can be arranged for guidance.
      </p>
      <p className="mt-5 h4 p-4">
      To arrange a Silent Solo Retreat, prior registration is required to secure a place. Please visit the Retreat Calendar and complete your online registration.
      </p>

      <h3 className="font-second dark-gold p-4 text-center mt-6">
        Retreats Calendar
      </h3>

      <div className="p-4 calander-box text-black align-item-center">
      <div className="calnder text-center mt-5">                <Calendar/></div>
      </div>

      <KutiesLayout/>

      <div className="btn-group2 mt-6">
        <img
          src={imageSix}
          alt="Right Top Image"
          width={300}
          onClick={handleClick}
          className="curser-pointer"
          id="internalRules"
        />
        <img
          src={imageFour}
          alt="Right Top Image"
          width={300}
          onClick={handleClick}
          className="curser-pointer"
          id="soloRetreatRegistration"
        />
      </div>

      <div className="btn-group2 mt-6">
        <img
          src={imageSeven}
          alt="Right Top Image"
          width={300}
          id="itemBring"
          className="curser-pointer"
          onClick={handleClick}
        />
        <img
          src={imageEight}
          alt="Right Top Image"
          width={300}
          id="timeTabel"
          onClick={handleClick}
          className="curser-pointer"
        />
      </div>

      <div className="mt-6 calander-box align-item-center p-4 text-center">
        <div className="c-details text-left">
          <h2 className="intro-text ">Contact Details</h2>
          <p className="font-p mt-4">Monastery : 035608 0918 / 0459 729 738</p>
          <p className="font-p">Mr Gamini : 0422 069 359</p>
          <p className="font-p">WhatsApp : 0422 069 359</p>
          <p className="font-p">E-mail : info@bvp.org.au</p>
        </div>
        <div className="d-button">
          <img src={imageFive} alt="Right Top Image" width={300} id="soloRequest" onClick={handleClick} className="curser-pointer" />
        </div>
      </div>

      <div className="bottom-box mt-6">
        <img src={imageThree} alt="bottom-image" width={600} />
      </div>
    </div>
  );
};

export default SoloRetreat;
